import { render, staticRenderFns } from "./invoice-sync-modal.vue?vue&type=template&id=4bc5b638&scoped=true&"
import script from "./invoice-sync-modal.vue?vue&type=script&lang=ts&"
export * from "./invoice-sync-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc5b638",
  null
  
)

export default component.exports